hrd.utils = {
	equals: function (obj1, obj2) {
		if (obj1 === obj2) return true;
		if (obj1 === null || obj2 === null) return false;
		if (obj1 === undefined || obj2 === undefined) return false;
		if (obj1 !== obj1 && obj2 !== obj2) return true; // NaN === NaN
		if(typeof obj1 === 'string'){
			return obj1 === obj2;
		}
		//Loop through properties in object 1
		for (var p in obj1) {
			//Check property exists on both objects
			if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) return false;

			switch (typeof (obj1[p])) {
				//Deep compare objects
				case 'object':
					if (!hrd.utils.equals(obj1[p], obj2[p])) return false;
					break;
				//Compare function code
				case 'function':
					return true; // ignore functions
					break;
				//Compare values
				default:
					if (obj1[p] != obj2[p]) return false;
			}
		}

		//Check object 2 for any extra properties
		for (var p in obj2) {
			if (typeof (obj1[p]) == 'undefined') return false;
		}
		return true;
	},
	/**
	 * Given an array, return a new array without duplicated values
	 */
	uniqueArray: function(arrArg) {
		arrArg = arrArg || [];
		return arrArg.filter(function(elem, pos, arr) {
			return arr.indexOf(elem) == pos;
		});
	},
	get: function(property, object, defaultValue){
		var v = this.getValueByPath(object, property);
		return (v == undefined) ? defaultValue : v;
	},
	getValueByPath: function(obj, path) {
		if(!(obj != null)){
			return null;
		}
		if(typeof path.indexOf !== 'function'){
			return null;
		}
		var i = path.indexOf('.');
		if (i == -1) {
			return obj[path];
		} else {
			var pathSegment = path.substring(0, i);
			obj = obj[pathSegment];
			if (obj == null) {
				return null;
			} else {
				path = path.substring(i + 1);
				return this.getValueByPath(obj, path);
			}
		}
	},
	setValueByPath: function(obj, path, value) {
		var i = path.indexOf('.');
		if (i == -1) {
        	obj[path] = value;
		} else {
			var tmp = obj;
			var pathSegment = path.substring(0, i);
			obj = obj[pathSegment];
			if (obj == null) {
				obj = new Object();
				tmp[pathSegment] = obj;
			}
			path = path.substring(i + 1);
			this.setValueByPath(obj, path, value);
		}
	},
	isEmpty : function(s){
		return !hrd.utils.isNotEmpty(s);
	},
	isNotEmpty : function(s){
		if(s == undefined){
			return false;
		} else {
			if(typeof s === 'string'){
				return !!(s != '' && s.trim() != '');
			} else {
				return true;
			}
		}
	},
	formatTime: function(time){
		return hrd.utils.isValidTime(time) ? time : jsonrpc.format.formatTime(time);
	},
	isValidTime: function(time){
		var re = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
		return new RegExp(re).test(time);
	},
	/**
	 *  Needed to convert NNNpx/NNNem and other css units to NNN as number
	 *  Avoid to use percentage
	 */
	widthAsNumber: function(w){
		return $('<div/>').css('width',  w).width();
	},
	replaceParams: function(message, params) {
		var re = /\{\{|\}\}|\{([^{}]+)\}/g;
		params = typeof params === 'object' ? params : Array.prototype.slice.call(arguments, 1);
	    return message.replace(re, function (m, n) {
	        if (m == "{{") { return "{"; }
	        if (m == "}}") { return "}"; }
	        /* used to solve something in the form: property|action|arg1|arg2|...|argN */
	        if(n.indexOf('|') !== -1){
	        	var tokens = n.split('|');
	        	var key = tokens[0];
	        	var action = tokens[1];
	        	var values = tokens.slice(2);
	        	// to expand for 'objectPath'
	        	return params[key][action](values);
	        } else {
	        	if(n.indexOf('.') !== -1){
	        		return objectPath.get(params, n)
	        	} else {
	        		return params[n];
	        	}
	        }
	    });
	},
	/**
	 * Utility method for combo attached to a DataTableProvider
	 */
	buildSelect: function(id, sProvider, oSettings) {},
	entityMap: {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&apos;',
		'/': '&#x2F;',
		'`': '&#x60;',
		'=': '&#x3D;'
	},
	escapeHtml:	function(string) {
		return String(string).replace(/[&<>"'`=\/]/g, function (s) {
			return hrd.utils.entityMap[s];
		});
	},
	/**
	 * narrowed an object copying only a subset of all available properties.
	 * As of now only 'flat' properties can be copied
	 */
	narrow: function(obj, props){
		var narrowedObj = {};
		if(props){
			props.forEach(p => (narrowedObj[p] = obj[p]));
		}
		return narrowedObj;
	},
	/**
	 * reduce an object copying only the properties with a 'not null' value, but not if it is to be ignored
	 */
	reduce: function(obj, ignoredProps) {
		ignoredProps = ignoredProps || [];
		var reducedObj = {};
		$.each(obj, function(property, value) {
			if(hrd.utils.isNotEmpty(value) || ignoredProps.includes(property)){
				reducedObj[property] = value;
			}
		})
		return reducedObj;
	},
	hpLink: function(url, targetTop) {
		if(hrd.utils.inIFrame()){
			if(!targetTop){
				window.top._goto(url);
			} else {
				window.top.document.location = url;
			}
		} else {
			document.location = url;
		}
	},
	executeTopFunction: function(fn, context, argAsArray){
		if(hrd.utils.inIFrame()){
			let actualFn = hrd.utils.get(fn, window.top);
			if(typeof actualFn == 'function'){
				context = (typeof context === 'string') ? hrd.utils.get(context, window.top) : context;
				actualFn.apply(context, argAsArray);
			} else {
				hrd.dashboard.errorDialog(`The function "${fn}" is not available`);
			}
		} else {
			hrd.dashboard.errorDialog(`The function "${fn}" cannot be executed in this scope`);
		}
	},
	inIFrame: function(){
		try {
			return window.self !== window.top;
		} catch (e) {
			return true;
		}
	},
	clearNewMenuStorageEntries: function() {
		(Storages.sessionStorage.keys() || []).forEach(/** @param key {string} */(key) => {
			if(key && key.includes("menu")) {
				Storages.sessionStorage.remove(key);
			}
		});
	},
	reloadWindow: function() {
		if(hrd.utils.inIFrame()){
			window.top.location.reload();
		} else {
			document.location.reload();
		}
	}
};